
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { FileText, Users, Settings, ExternalLink, Users2 } from 'lucide-react';

const AdminDashboardCard: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 md:col-span-2">
      <h3 className="text-lg font-semibold mb-4">Admin Dashboard</h3>
      <p className="text-gray-600 mb-4">
        Access the admin dashboard to manage clients, employees, content, and system settings.
      </p>
      <div className="space-y-3">
        <Button 
          onClick={() => navigate('/admin', { state: { activeTab: 'clients' } })}
          variant="outline"
          className="w-full flex items-center"
        >
          <Users className="mr-2 h-4 w-4" />
          Client Management
        </Button>
        
        <Button 
          onClick={() => navigate('/admin', { state: { activeTab: 'employees' } })}
          variant="outline"
          className="w-full flex items-center"
        >
          <Users2 className="mr-2 h-4 w-4" />
          Employee Management
        </Button>
        
        <Button 
          onClick={() => navigate('/admin', { state: { activeTab: 'content' } })}
          variant="outline"
          className="w-full flex items-center"
        >
          <FileText className="mr-2 h-4 w-4" />
          Content & Marketing
        </Button>
        
        <Button 
          onClick={() => navigate('/admin', { state: { activeTab: 'links' } })}
          variant="outline"
          className="w-full flex items-center"
        >
          <ExternalLink className="mr-2 h-4 w-4" />
          Employee Links
        </Button>
        
        <Button 
          onClick={() => navigate('/admin', { state: { activeTab: 'settings' } })}
          variant="outline"
          className="w-full flex items-center"
        >
          <Settings className="mr-2 h-4 w-4" />
          Admin Settings
        </Button>
      </div>
    </div>
  );
};

export default AdminDashboardCard;
